import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ProceedService {
  public proceed$ = new Subject();

  proceed() {
    this.proceed$.next({});
  }
}
